import React, { Component } from "react";
import "../styles/Button.css";

class Button extends Component {
  state = {
    pressed: false,
    hovered: false
  };

  mouseDown() {
    this.setState({ pressed: true });
  }

  mouseUp() {
    this.setState({ pressed: false });
  }

  mouseEnter() {
    this.setState({ hovered: true });
  }

  mouseLeave() {
    this.setState({ hovered: false });
  }

  render() {
    const classes = ["button"];
    let color = this.props.blue ? "blue" : "gray";
    classes.push(`button--${color}`);

    if (this.state.hovered) {
      classes.push(`button--${color}-hovered`);
    }
    if (this.props.selected || this.state.pressed) {
      classes.push(`button--${color}-selected`);
    }

    return (
      <button
        tabIndex={this.props.tabIndex}
        className={classes.join(" ")}
        onMouseDown={this.mouseDown.bind(this)}
        onMouseUp={this.mouseUp.bind(this)}
        onMouseEnter={this.mouseEnter.bind(this)}
        onMouseLeave={this.mouseLeave.bind(this)}
        onClick={() => this.props.onClicked()}
      >
        {this.props.children}
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/elements/Button.js